<template>
  <div id="sso">
  <el-dialog :visible.sync="corpShow" show-close="false">
     <h5 slot="title">新商户登陆</h5>
    <el-form :model="merchant" ref="newForm">
      <el-form-item prop="shortName" label="店铺名称" required>
        <el-input v-model="merchant.shortName" placeholder="请输入站点名称"/>
      </el-form-item>
      <el-form-item prop="currency" label="货币代码" required>
        <el-input v-model="merchant.currency" placeholder="请输入货币代码如:USD"/>
      </el-form-item>
      <el-form-item prop="CountryCode" label="国家代码" required>
        <el-input v-model="merchant.CountryCode" placeholder="国家代码，如US"/>
      </el-form-item>
      <el-form-item prop="address" label="联系地址" required>
        <el-input v-model="merchant.address" placeholder="请输入站点联系地址"/>
      </el-form-item>
    </el-form>
     <div slot="footer">
       <el-button-group>
         <el-button type="primary" @click="handlemerchant('newForm')"><i class="fa fa-hand-o-up"></i>创建新公司</el-button>
       </el-button-group>
     </div>
   </el-dialog>
    <el-dialog :visible.sync="stafShow" show-close="false">
      <h5 slot="title">新员工入职申请</h5>
      <el-form :model="staf" ref="stafForm">
        <el-form-item prop="name" label="姓名" required>
          <el-input v-model="staf.name" placeholder="请输入姓名"/>
        </el-form-item>
        <el-form-item prop="tel" label="联系电话" required>
          <el-input v-model="staf.tel" placeholder="请输入联系电话"/>
        </el-form-item>
        <el-form-item prop="email" label="邮箱" required>
          <el-input v-model="staf.email" placeholder="请输入公司邮箱"/>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button-group>
          <el-button type="primary" @click="handleStaf('stafForm')"><i class="fa fa-hand-o-up"></i>员工入职申请</el-button>
        </el-button-group>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'sso',
  data () {
    return {
      merchant: {},
      staf: {},
      corpShow: false,
      stafShow: false
    }
  },
  mounted () {
    this.$pageloading()
    this.loadSign()
  },
  methods: {
    handlemerchant: function (form) {
      var that = this
      that.$refs[form].validate(function (valid) {
        if (valid) {
          var para = that.merchant
          para.ssoData = that.$route.query.playload
          var api = that.$apiurl.replace('merchant', '') + 'apply/merchant'
          that.$pageloading()
          that.$http.post(api, para).then(function (ret) {
            that.$loadend()
            if (ret.body.data.corpId) {
              that.corpShow = false
              that.stafShow = true
            } else {
              that.$message.warning('创建公司失败，请稍后重试！')
            }
          })
        }
      })
    },
    handleStaf: function (form) {
      var that = this
      that.$refs[form].validate(function (valid) {
        if (valid) {
          var para = that.staf
          para.ssoData = that.$route.query.playload
          var api = that.$apiurl.replace('merchant', '') + 'apply/user'
          that.$pageloading()
          that.$http.post(api, para).then(function (ret) {
            that.$loadend()
            if (ret.body.data.code === 200) {
              that.loadSign()
            } else {
              that.$message.warning('入职申请失败，请稍后重试！')
            }
          })
        }
      })
    },
    loadSign: function () {
      var that = this
      var api = that.$apiurl.replace('merchant', '') + 'sso/sgin'
      var para = that.$route.query
      that.$http.post(api, para).then(function (ret) {
        if (ret.body.data.code === 200) {
          that.$message.success('登陆成功，系统即将返回')
          localStorage.setItem('token', ret.body.data.token)
          window.location.href = '/admin/'
        } else if (ret.body.data.code === 100) {
          if (!ret.body.data.merchant) {
            that.corpShow = true
          } else {
            that.stafShow = true
          }
        } else {
          that.$message.warning('非法登陆，请确认或则开通相关服务后登陆')
          setTimeout(() => {
            window.location.href = that.$ssourl
          }, 5000)
        }
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/sso.vue